// extracted by mini-css-extract-plugin
export default {"icon":"FormItemLabel_icon__6n+Io","label":"FormItemLabel_label__7dDQv"};